var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { CheckmarkIcon } from '@inter-ikea-kompis/icons';
import { IdGenerator } from '@inter-ikea-kompis/utilities';
import { Icon } from '@inter-ikea-kompis/component-icon';
import { Text } from '@inter-ikea-kompis/component-text';
import CheckboxAlignButtonEnum from '../../enums/CheckboxAlignButtonEnum.js';
import CheckboxLayoutEnum from '../../enums/CheckboxLayoutEnum.js';
import CheckboxStyle from './CheckboxStyle.js';
/**
 * @deprecated This component has been deprecated, see Kompis page for more info.
 
 * @event change When the checkbox is checked or unchecked
 */
export default class Checkbox extends KompisElement {
    constructor() {
        super(...arguments);
        // A text that describes the action of the checkbox.
        this.label = null;
        // Like a native input element.
        this.required = false;
        // Like a native input element.
        this.disabled = false;
        // Applicable when type is switch or checkbox.
        this.checked = false;
        // Error message.
        this.errorMessage = null;
        // Is input invalid.
        this.invalid = false;
        // Where the label should be.
        this.alignButton = CheckboxAlignButtonEnum.left;
        // Changes the style of the checkbox.
        this.layout = CheckboxLayoutEnum.emphasised;
        // Enables the hovered styling.
        this.hovered = false;
        this.showOutline = false; // State to show outline
        this.pointerIsDown = false; // To distinguish between how focus have been captured
        this.uniqueId = new IdGenerator().generateId();
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        const direction = window.getComputedStyle(this).direction;
        return html `
			<style>
				${CheckboxStyle.getStyle({
            isDisabled: this.disabled,
            showOutline: this.showOutline,
            isChecked: this.checked,
            invalid: this.invalid,
            theme: this.theme,
            alignButton: this.alignButton,
            layout: this.layout,
            hover: this.hovered,
            direction: direction
        })}
			</style>
			${this.getCheckbox()}
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-icon', Icon);
        this.customElements.define('kompis-text', Text);
        super.connectedCallback();
    }
    /**
     * @returns Template.
     */
    getCheckbox() {
        return html `
			<div class="container">
				<div class="checkbox">
					<div class="outline"></div>
					<kompis-icon .theme="${this.theme}" .icon="${CheckmarkIcon}"></kompis-icon>
				</div>
				${this.getCheckableInputElement()} ${this.getLabel()}
			</div>
			${this.getErrorMessage()}
		`;
    }
    /**
     * @returns Template.
     */
    getCheckableInputElement() {
        return html `
			<input
				type="checkbox"
				?checked="${this.checked}"
				?disabled="${this.disabled}"
				id="${this.uniqueId}"
				@touchdown="${this.onPointerDown.bind(this)}"
				@pointerdown="${this.onPointerDown.bind(this)}"
				@focusout="${this.onFocusOut.bind(this)}"
				@focus="${this.onFocusIn.bind(this)}"
				@change="${this.onChange.bind(this)}"
				>
			</input>
    	`;
    }
    /**
     * @returns Template.
     */
    getErrorMessage() {
        if (!this.invalid) {
            return null;
        }
        return html `
			<span class="errorMessage">
				<kompis-text .theme="${this.theme}" .type="${ThemeFontStyleTypeEnum.bodyMedium}"
					>${this.errorMessage}</kompis-text
				>
			</span>
		`;
    }
    /**
     * HTML event handler.
     */
    onFocusOut() {
        this.showOutline = false;
        this.pointerIsDown = false;
        this.update();
    }
    /**
     * HTML event handler.
     */
    onFocusIn() {
        this.showOutline = !this.pointerIsDown;
        this.update();
    }
    /**
     * HTML event handler.
     *
     * @param event Pointer event.
     */
    onPointerDown(event) {
        event.preventDefault();
        this.pointerIsDown = true;
        this.showOutline = false;
    }
    /**
     * Runs when input event occurs.
     *
     * @param event HTMLEvent.
     */
    onChange(event) {
        event.stopPropagation();
        event.preventDefault();
        this.dispatchEvent(new CustomEvent('change', {
            bubbles: true,
            detail: {
                checked: event.target.checked
            }
        }));
    }
    /**
     * @returns Template.
     */
    getLabel() {
        if (!this.label) {
            return null;
        }
        return html `
			<div class="labelDivider"></div>
			<label
				for="${this.uniqueId}"
				@touchdown="${this.onPointerDown.bind(this)}"
				@pointerdown="${this.onPointerDown.bind(this)}"
			>
				<kompis-text .theme="${this.theme}" .type="${ThemeFontStyleTypeEnum.bodyMedium}">
					${this.label}
				</kompis-text>
			</label>
		`;
    }
}
__decorate([
    property({ type: String })
], Checkbox.prototype, "label", void 0);
__decorate([
    property({ type: Boolean })
], Checkbox.prototype, "required", void 0);
__decorate([
    property({ type: Boolean })
], Checkbox.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], Checkbox.prototype, "checked", void 0);
__decorate([
    property({ type: Object, required: true })
], Checkbox.prototype, "theme", void 0);
__decorate([
    property({ type: String })
], Checkbox.prototype, "errorMessage", void 0);
__decorate([
    property({ type: Boolean })
], Checkbox.prototype, "invalid", void 0);
__decorate([
    property({ type: String })
], Checkbox.prototype, "alignButton", void 0);
__decorate([
    property({ type: String })
], Checkbox.prototype, "layout", void 0);
__decorate([
    property({ type: Boolean })
], Checkbox.prototype, "hovered", void 0);
//# sourceMappingURL=Checkbox.js.map